module.exports = __webpack_public_path__ + "assets/img/bonus@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/bonus@2x.png
// module id = 127
// module chunks = 0